import {AbstractService} from "./abstract.service";
import {Injectable} from "@angular/core";
import {ItemUnit} from "../libs/enum/item-unit.enum";
import {Feature} from "../libs/enum/feature.enum";
import {isDefined, isFalse, notDefined} from "../libs/utils/epic.utils";

@Injectable({providedIn: 'root'})
export class UnitService extends AbstractService {

  private readonly WOOD_INDUSTRY_UNITS: ItemUnit[] = [
    ItemUnit.CUBIC_METER,
    ItemUnit.LOOSE_CUBIC_METERS,
    ItemUnit.STACKED_CUBIC_METER,
    ItemUnit.SOLID_CUBIC_METER,
    ItemUnit.STERE,
  ];

  public getItemUnits(current?: ItemUnit): ItemUnit[] {
    let units = Object.values(ItemUnit);
    if (isFalse(this.getOrg().isFeatureEnabled(Feature.WOODWORKING_EXTENDED))) {
      units = units.filter((u) => !this.isWoodIndustryUnit(u));
    }
    if (isDefined(current) && notDefined(units.find((u) => u === current))) {
      units.push(current);
    }
    return units;
  }

  public isWoodIndustryUnit(unit: ItemUnit): boolean {
    return this.WOOD_INDUSTRY_UNITS.includes(unit);
  }
}
